import { useTranslation } from 'react-i18next';
import { searchTypesEnum } from '../constants/Enums';
import { i18nNS } from '../i18n';

const useTextInterstitialOptions = (type) => {
  const { t } = useTranslation(i18nNS.common);

  const rest = [
    {
      title: t('common:Interstitial.Applying'),
      desc: t('common:Interstitial.CompanyPolicy'),
    },
    {
      title: t('common:Interstitial.Adding'),
      desc: t('common:Interstitial.CompanyDiscounts'),
    },
    {
      title: t('common:Interstitial.Making'),
      desc: t('common:Interstitial.BussinessTravelFun'),
    },
  ];
  let responseType = [];

  switch (type) {
    case searchTypesEnum.AIR:
      responseType = [
        {
          title: t('common:Interstitial.Searching'),
          desc: t('common:Interstitial.SearchAir'),
        },
      ];
      break;
    case searchTypesEnum.CAR:
      responseType = [
        {
          title: t('common:Interstitial.Searching'),
          desc: t('common:Interstitial.SearchCar'),
        },
      ];
      break;
    case searchTypesEnum.HOTEL:
      responseType = [
        {
          title: t('common:Interstitial.Searching'),
          desc: t('common:Interstitial.SearchHotel'),
        },
      ];
      break;
    case searchTypesEnum.RAIL:
      responseType = [
        {
          title: t('common:Interstitial.Select'),
          desc: t('common:Interstitial.SearchRail'),
        },
      ];
      break;
  }

  return responseType.concat(rest);
};

export default useTextInterstitialOptions;
